module.exports = __webpack_public_path__ + "static/media/product-screen-1.04353cf8.png";